import { generateTypes } from '@evmos/eip712';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions';
import {
  MsgCancelUnbondingDelegation as MsgCancelUnbondingDelegationProto,
} from '../proto/cosmos/staking/v1beta1/tx_pb';
import { MsgCancelUnbondingDelegation } from '../ts-client/v1beta1/tx';

const MSG_CANCEL_UNBONDING_DELEGATION_TYPES = (params: MsgCancelUnbondingDelegation) => ({
  MsgValue: [
    { name: 'delegator_address', type: 'string' },
    { name: 'validator_address', type: 'string' },
    ...(params.amount ? [ { name: 'amount', type: 'TypeAmount' } ] : []),
    { name: 'creation_height', type: 'int64' },
  ],
  ...(params.amount ? {
    TypeAmount: [
      { name: 'denom', type: 'string' },
      { name: 'amount', type: 'string' },
    ],
  } : {}),
});

export const createTxMsgCancelUnbondingDelegation = (
  context: TxContext,
  params: MsgCancelUnbondingDelegation,
): TxPayload => {
  const typedData = createEIP712MsgCancelUnbondingDelegation(context, params);
  const cosmosMsg = createCosmosMsgCancelUnbondingDelegation(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgCancelUnbondingDelegation = (
  context: TxContext,
  params: MsgCancelUnbondingDelegation,
): EIP712TypedData => {
  const types = generateTypes(MSG_CANCEL_UNBONDING_DELEGATION_TYPES(params));
  const message = createMsgCancelUnbondingDelegation(params);
  return { types, message };
};

const createCosmosMsgCancelUnbondingDelegation = (
  context: TxContext,
  params: MsgCancelUnbondingDelegation,
) => {
  const message = new MsgCancelUnbondingDelegationProto(params as any);
  return { message, path: MsgCancelUnbondingDelegationProto.typeName };
};

export function createMsgCancelUnbondingDelegation(params: MsgCancelUnbondingDelegation): object | object[] {
  return {
    type: 'cosmos-sdk/MsgCancelUnbondingDelegation',
    value: {
      delegator_address: params.delegatorAddress,
      validator_address: params.validatorAddress,
      ...(params.amount ? {
        amount: {
          denom: params.amount.denom,
          amount: params.amount.amount
        }
      } : {}),
      creation_height: params.creationHeight.toString(),
    },
  };
}

